<ng-container *transloco="let t">
  @if (loadingService.isLoading()) {
    <div class="app-loader" role="status" [attr.aria-label]="t('common.loading')">
      <mat-progress-spinner
        class="app-loader__spinner"
        mode="indeterminate"
        diameter="56"
      />
    </div>
  }
</ng-container>
